import React from 'react';
import { CTASection } from '../../components/CTASection';
export function HomeCTA() {
  return <section className="py-20 bg-background" data-id="element-326">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <CTASection headline="Ready to Build Something Exceptional?" body="Magnus Software accepts new clients by referral to ensure the best fit and maintain our commitment to quality. If a trusted partner recommended us, we'd love to discuss your project." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-328" />
      </div>
    </section>;
}